import { useEffect, useState } from "react";
import { IAlert } from "../interface/IAlert";
import { getWebNotificationRoute } from "@api-routes/notifications";
import { getResponseToState, IAlertListResponse } from "../mappers/getAlertListMapper";
import { useFetch } from "@common/hook/useFetch";

export const useAlertList = () => {
    const [alertList, setAlertList] = useState<IAlert[]>([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [getAlertListState, { get }] = useFetch();

    const getAlertList = () =>
        get<IAlertListResponse>(getWebNotificationRoute(currentPage)).then((alertListResponse) => {
            if (alertListResponse?.webNotifications) {
                const alertListMapped = getResponseToState(alertListResponse);

                setAlertList(alertListMapped.content);
                setTotalPages(alertListMapped.totalPages);
            }
        });

    useEffect(() => {
        getAlertList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    return { alertList, getAlertListState, getAlertList, currentPage, setCurrentPage, totalPages };
};
